import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Tahasil from './pages/Tahasil';
import Preloader from './pages/Preloader';
import YojnaPage from './pages/YojnaPage';
import YojanaTable from './pages/YojanaTable';
import LoginForm from './pages/LoginForm';
import Cards from './pages/CardData';
import Chart from './pages/chart';
import { XDChart } from './pages/XDChart';
import VisitPage from './pages/visitPage';
import EOfficeTable from './pages/EOfficeTable';
import ApaleSarkarTable from './pages/ApaleSarkarTable';
import LokaadalatTable from './pages/LokaadalatTable';
import StaticTable from './pages/StaticTable';
import TakararPranaliForm from './pages/TakrarPranaliForm';
import TakrarPranaliData from './pages/TakrarPranaliData';
import SearchComponent from './pages/SearchTakrar';
import TopBarStatic from './pages/TopBarStatic';

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  return (
    <>
      {loading ? (
        <Preloader />
      ) : (
        <Routes>
          <Route path="/" element={<LoginForm />} />
          <Route path="/home" element={<Home/>} />
          <Route path="/tahasil" element={<Tahasil/>} />
          <Route path="/yojnaPage" element={<YojnaPage/>} />
          <Route path="/chart" element={<Chart/>}/>
          <Route path="/cards" element={<Cards/>} />
          <Route path="/yojnaPage/yojnaTable" element={<YojanaTable/>} />
          <Route path="/XDchart" element={<XDChart/>}/>
          <Route path="/visit" element={<VisitPage/>}/>
          <Route path="/eoffice" element={<EOfficeTable/>}/>
          <Route path="/apalesarkar" element={<ApaleSarkarTable/>}/>
          <Route path="/lokaadalat" element={<LokaadalatTable/>}/>
          <Route path="/table" element={<StaticTable/>}/>
          <Route path="/takrar-pranali-form" element={<TakararPranaliForm/>}/>
          <Route path="/takrar-pranali" element={<TakrarPranaliData/>}/>
          <Route path="/takrar-status" element={<SearchComponent/>}/>
          <Route path="/topBar-static" element={<TopBarStatic/>}/>
        </Routes>
      )}
    </>
  );
}

export default App;
